function buildRedirectUriFromParams (params) {
  let redirectUri = params.redirectUri + '?'
  for(const key in params) {
    if(key !== 'redirectUri') {
      redirectUri += '&' + key + '=' + encodeURIComponent(params[key])
    }
  }
  return redirectUri
}

export { buildRedirectUriFromParams }
